import React from 'react';
import { useI18n } from '../../../../contexts/I18nContext';

const ImageToVideoUpload = ({
  file,
  setFile,
  keyframe,
  setKeyframe,
  startFrame,
  setStartFrame,
  endFrame,
  setEndFrame,
  inputRef,
  inputStartRef,
  inputEndRef,
  onPick,
  onPickStart,
  onPickEnd,
  openPreview
}) => {
  const { t } = useI18n();

  return (
    <div>
      <div className="veo2-section">
        <div className="veo2-section__title">{keyframe ? t('videoGeneration.veo.keyframe.title') : t('videoGeneration.veo.upload.uploadTitle')}</div>
        <div className="veo2-divider" />
        {!keyframe && (
          <div
            className={`veo2-upload ${file ? 'has-file' : ''}`}
            onClick={() => !file && inputRef.current && inputRef.current.click()}
          >
            {!file && (
              <div className="veo2-upload__inner">
                <div className="veo2-upload__icon">⬆︎</div>
                <div className="veo2-upload__title">{t('videoGeneration.veo.upload.uploadTitle')}</div>
                <div className="veo2-upload__desc">{t('videoGeneration.veo.keyframe.imageFormats')}</div>
              </div>
            )}
            {file && (
              <div className="veo2-upload__preview" onClick={(e) => { e.stopPropagation(); openPreview(file); }}>
                <img className="veo2-upload__img" src={URL.createObjectURL(file)} alt="preview" />
                <div className="veo2-upload__actions">
                  <button className="veo2-action is-danger" onClick={(e) => { e.stopPropagation(); setFile(null); if (inputRef.current) inputRef.current.value = null; }}>×</button>
                  <button className="veo2-action is-ok" onClick={(e) => { e.stopPropagation(); inputRef.current && inputRef.current.click(); }}>↺</button>
                </div>
              </div>
            )}
            <input ref={inputRef} type="file" accept=".jpg,.jpeg,.png,.webp" onChange={onPick} hidden />
          </div>
        )}
        {keyframe && (
          <div className="veo2-frame-grid">
            <div
              className={`veo2-upload veo2-upload--frame ${startFrame ? 'has-file' : ''}`}
              onClick={() => !startFrame && inputStartRef.current && inputStartRef.current.click()}
            >
              {!startFrame && (
                <div className="veo2-upload__inner">
                  <div className="veo2-upload__icon">⬆︎</div>
                  <div className="veo2-upload__title">{t('videoGeneration.veo.keyframe.start')}</div>
                  <div className="veo2-upload__desc">{t('videoGeneration.veo.keyframe.imageFormats')}</div>
                </div>
              )}
              {startFrame && (
                <div className="veo2-upload__preview" onClick={(e) => { e.stopPropagation(); openPreview(startFrame); }}>
                  <img className="veo2-upload__img" src={URL.createObjectURL(startFrame)} alt="start" />
                  <div className="veo2-upload__actions">
                    <button className="veo2-action is-danger" onClick={(e) => { e.stopPropagation(); setStartFrame(null); if (inputStartRef.current) inputStartRef.current.value = null; }}>×</button>
                    <button className="veo2-action is-ok" onClick={(e) => { e.stopPropagation(); inputStartRef.current && inputStartRef.current.click(); }}>↺</button>
                  </div>
                </div>
              )}
              <input ref={inputStartRef} type="file" accept=".jpg,.jpeg,.png,.webp" onChange={onPickStart} hidden />
            </div>

            <div
              className={`veo2-upload veo2-upload--frame ${endFrame ? 'has-file' : ''}`}
              onClick={() => !endFrame && inputEndRef.current && inputEndRef.current.click()}
            >
              {!endFrame && (
                <div className="veo2-upload__inner">
                  <div className="veo2-upload__icon">⬆︎</div>
                  <div className="veo2-upload__title">{t('videoGeneration.veo.keyframe.end')}</div>
                  <div className="veo2-upload__desc">{t('videoGeneration.veo.keyframe.imageFormats')}</div>
                </div>
              )}
              {endFrame && (
                <div className="veo2-upload__preview" onClick={(e) => { e.stopPropagation(); openPreview(endFrame); }}>
                  <img className="veo2-upload__img" src={URL.createObjectURL(endFrame)} alt="end" />
                  <div className="veo2-upload__actions">
                    <button className="veo2-action is-danger" onClick={(e) => { e.stopPropagation(); setEndFrame(null); if (inputEndRef.current) inputEndRef.current.value = null; }}>×</button>
                    <button className="veo2-action is-ok" onClick={(e) => { e.stopPropagation(); inputEndRef.current && inputEndRef.current.click(); }}>↺</button>
                  </div>
                </div>
              )}
              <input ref={inputEndRef} type="file" accept=".jpg,.jpeg,.png,.webp" onChange={onPickEnd} hidden />
            </div>
          </div>
        )}
      </div>

      <div className="veo2-keyframe">
        <div className="veo2-keyframe__header">
          <div className="veo2-keyframe__title">{t('videoGeneration.veo.keyframe.title')}</div>
          <button className={`veo2-switch ${keyframe ? 'is-on' : ''}`} onClick={() => setKeyframe(!keyframe)}>
            <span className="veo2-switch__knob" />
          </button>
        </div>
        <div className="veo2-keyframe__info">
          <span className="dot" />
          {t('videoGeneration.veo.keyframe.info')}
        </div>
      </div>
    </div>
  );
};

export default ImageToVideoUpload;
